import React from "react";
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from "recharts";
import { useClientRequestsBreakdown } from "./useClientRequestsBreakdown";
import { CHART_COLORS } from "../chartColors";
import DashboardSectionCard from "../components/DashboardSectionCard";

const ClientRequestsOverviewChart = () => {
  const { canView, isFetching, notStarted, inProgress, completedToday, overdue } = useClientRequestsBreakdown();
  if (!canView) return null;

  const data = [
    { name: "Not Started", value: notStarted, color: CHART_COLORS[4] },
    { name: "In Progress", value: inProgress, color: CHART_COLORS[1] },
    { name: "Completed Today", value: completedToday, color: CHART_COLORS[2] },
    { name: "Overdue", value: overdue, color: CHART_COLORS[3] },
  ].filter((d) => d.value > 0);

  return (
    <div className="col-12 col-xl-4">
      <DashboardSectionCard title="Client Requests Overview" isLoading={isFetching} isEmpty={data.length === 0}>
        <ResponsiveContainer width="100%" height={220}>
          <PieChart>
            <Pie data={data} dataKey="value" nameKey="name" innerRadius={50} outerRadius={80} paddingAngle={2}>
              {data.map((entry) => (
                <Cell key={entry.name} fill={entry.color} />
              ))}
            </Pie>
            <Legend layout="vertical" align="right" verticalAlign="middle" wrapperStyle={{ fontSize: 11 }} />
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </DashboardSectionCard>
    </div>
  );
};

export default ClientRequestsOverviewChart;
